import { toApiAcceptedDateFormat } from './../../../payload.utils';

export class RequestLinkBankForm {
  constructor() {
    this.bankDetails = {};
    this.responseData = {};
    this.action = 'CREATE';
    this.isDefault = true;
    this.isWithdrawal = true;
    this.saveBankAccount = true;
    this.bankPaymentOption = null;
    this.beneficiaryAccount = null;
    this.beneficiaryAccountName = null;
    this.beneficiaryAddress = null;
    this.beneficiaryCode = null;
    this.beneficiaryBank = null;
    this.bankAddress = null;
    this.dateOfBirth = null;
    this.citizenship = null;

    this.props = {
      isSubmitting: false,
      isReady: false,
      readOnly: false
    };

    this.successMessage = {
      title: 'Success',
      body: 'Bank account successfully created.',
    };
  }

  get isReadOnly() {
    return this.props.readOnly;
  }

  reset() {
    this.action = 'CREATE';
    this.bankPaymentOption = null;
    this.isDefault = true;
    this.isWithdrawal = true;
    this.saveBankAccount = true;
    this.beneficiaryAccount = null;
    this.beneficiaryAccountName = null;
    this.beneficiaryAddress = null;
    this.beneficiaryCode = null;
    this.beneficiaryBank = null;
    this.bankAddress = null;
    this.dateOfBirth = null;
    this.citizenship = null;
  }

  toPayload() {
    let payload = {
      memberPaymentOption: {
        is_active: this.saveBankAccount,
        is_default: this.isDefault,
        is_withdrawal: this.isWithdrawal,
        account_id: this.beneficiaryAccount,
        account_name: this.beneficiaryAccountName,
        birth_date: toApiAcceptedDateFormat(this.dateOfBirth),
        citizenship: this.citizenship,
        account_address: this.beneficiaryAddress,
        swift_code: this.beneficiaryCode,
        bank_name: this.beneficiaryBank,
        bank_address: this.bankAddress,
        notes: '',
      }
    };

    return payload;
  }

  toUpdatePayload() {
    let payload = {
      memberPaymentOption: {
        memberPaymentOptionId: this.bankPaymentOption,
        is_active: this.saveBankAccount,
        is_default: this.isDefault,
        is_withdrawal: this.isWithdrawal,
        account_id: this.beneficiaryAccount,
        account_name: this.beneficiaryAccountName,
        birth_date: toApiAcceptedDateFormat(this.dateOfBirth),
        citizenship: this.citizenship,
        account_address: this.beneficiaryAddress,
        swift_code: this.beneficiaryCode,
        bank_name: this.beneficiaryBank,
        bank_address: this.bankAddress,
        notes: '',
      }
    };

    return payload;
  }

  toDeletePayload() {
    let payload = {
      memberPaymentOptionDelete: {
        memberPaymentOptionId: this.bankPaymentOption
      }
    };

    return payload;
  }

}

export default RequestLinkBankForm;



// WEBPACK FOOTER //
// ./client/app/shared/system-components/link-bank-widget/model/form.model.js